import React, { Component } from 'react'
import { Button, Col, Container, Row, Tooltip } from 'reactstrap'
import { inject, observer } from 'mobx-react'
import OrcamentoExportStore from '../stores/OrcamentoExportStore';
import FiltrosOrcamentoExport from '../components/FiltrosOrcamentoExport';
import Footer from '../../../../comum/components/Footer';
import FooterContent from '../../../../comum/components/FooterContent';
import ModalForm from '../../../../comum/components/ModalForm';
import FormInputSimples from '../../../../comum/components/FormInputSimples';
import TabelaOrcamentoExport from '../components/TabelaOrcamentoExport';
import ModalAviso from '../../../../comum/components/ModalAviso';
import FooterOptions from '../../../../comum/components/FooterOptions';

@inject("store")
@observer
export class OrcamentoExport extends Component {

    constructor(props) {
        super(props)

        this.appStore = this.props.store.appStore;
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;

        this.controller = new OrcamentoExportStore()
        this.consultaController = this.props.controller

    }

    componentDidMount() {

        this.appStore.showVoltarTopBar(true, '/consulta-orcamentos', null, this.consultaController.fecharTelaImportExport);
        this.tituloPaginaStore.setTitulo("Orçamento de Exportação");

    }

    componentWillUnmount() {
        this.appStore.showVoltarTopBar(false);
        this.tituloPaginaStore.setTitulo("Orçamentos");
        this.consultaController.fecharModalNovoOrcamento()
    }
    modalAlerta() {
        return this.controller.alerta && <ModalAviso
            onClickFechar={this.controller.fecharModalAviso}
        >
            <h2>{this.controller.alerta}</h2>
        </ModalAviso>
    }

    modalIncluirRefCliente() {

        return this.controller.modalGerarBoleto && <ModalForm
            className="incluir-cliente"
            salvando={this.controller.loadingBoleto}
            labelConfirmar="SIM"
            labelCancelar="NÃO"
            onClickSalvar={this.controller.gerarBoleto}
            onClickCancelar={this.controller.fecharModalBoleto}
        >
            <h2>
                Gerar boleto
            </h2>
            <FormInputSimples
                className="px-0"
                titulo="Referência cliente"
                dado={this.controller.addCliente}
                onChange={this.controller.setCliente}
                iconeInfo={true}
                extraInfo="Preenchimento não obrigatório"
            />
        </ModalForm>

    }

    renderBotaoGerarBoleto() {
        if (this.controller.permiteGerarBoleto()) {
            return <Button
                onClick={this.controller.abrirModalBoleto}
                className="btn-primary"
            >
                GERAR BOLETO
            </Button>;
        } else {
            return this.controller.listaSelecionados.length > 0 && <span className="mr-1 btn-primary">Selecione apenas serviços de mesmo cliente</span>
        }
    }

    render() {
        return (
            <div className="form-wrapper">
                {this.modalAlerta()}
                {this.modalIncluirRefCliente()}
                <Container className="liberacao-cabotagem" fluid>
                    <FiltrosOrcamentoExport controller={this.controller} />
                    <TabelaOrcamentoExport controller={this.controller} />
                </Container>
                <Footer>
                    <FooterContent>
                        {
                            this.controller.filtrado && window.innerWidth > 850
                                ? <React.Fragment>
                                    {
                                        this.controller.listaSelecionados.length > 0
                                            ? <React.Fragment>
                                                <b>
                                                    {this.controller.listaSelecionados.length}
                                                </b> Solicitações selecionadas
                                </React.Fragment>
                                            : <React.Fragment>
                                                <b>
                                                    {this.controller.listaExportacao.length}
                                                </b> Solicitações registradas
                                </React.Fragment>
                                    }
                            -
                            <Button className="btn-primary px-0" onClick={this.controller.pesquisar}>Atualizar lista</Button>
                                </React.Fragment>
                                : null
                        }

                    </FooterContent>
                    <FooterOptions>
                        {
                            this.controller.filtrado && this.controller.dadosExportacao !== null
                                ?
                                <React.Fragment>
                                    <div className="total-pagamento">
                                        Total
                                </div>
                                    <div className="box-valor">
                                        {this.controller.dadosExportacao.TotalPagar
                                            ? this.controller.dadosExportacao.TotalPagar.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2 })
                                            : (0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2 })
                                        }
                                    </div>
                                    <div className="total-pagamento">
                                        A faturar
                                </div>
                                    <div className="box-valor">
                                        {this.controller.calculaTotal()}
                                    </div>
                                </React.Fragment>
                                : null
                        }
                    </FooterOptions>
                    <FooterContent className="right-pos">
                        {this.renderBotaoGerarBoleto()}
                    </FooterContent>
                </Footer>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/faturamento/orcamento/exportacao/telas/OrcamentoExport.js